import { Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/models';
import { AuthService, OrganizationService } from 'src/app/services';
import { MemberRoleEnum } from 'src/enumerators';

@Component({
  selector: 'app-sidebar-settings',
  templateUrl: './sidebar-settings.component.html',
  styleUrls: ['./sidebar-settings.component.css']
})
export class SidebarSettingsComponent implements OnInit {

  toggleOpen: boolean = false;
  memberRoleEnum = MemberRoleEnum;
  org: Organization;
  checkSuperAdmin = false;

  constructor(
    private _organizationService: OrganizationService,
    private _authService: AuthService,

  ) { }

  ngOnInit(): void {
    this._authService.memberSub.asObservable().subscribe((next) => {
      if (!next) return;
      this.checkSuperAdmin = this._authService?.currentMember?.superAdmin

      if (!this._organizationService.organization) {
        this._organizationService.getCurrentOrg(false).subscribe(
          (res: Organization) => this.org = res,
        )
      } else {
        this.org = this._organizationService.organization;
      }
    })
  }

}
